export default function startExportingJob(jobId: string, date: Date): string {
  return `/exporting/jobs/${jobId}/start?date=${date.getTime()}`;
}
